import { render, staticRenderFns } from "./ProductSwatchesStatic.vue?vue&type=template&id=2af2bb4d&scoped=true&lang=pug&"
import script from "./ProductSwatchesStatic.vue?vue&type=script&lang=js&"
export * from "./ProductSwatchesStatic.vue?vue&type=script&lang=js&"
import style0 from "./ProductSwatchesStatic.vue?vue&type=style&index=0&id=2af2bb4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af2bb4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af2bb4d')) {
      api.createRecord('2af2bb4d', component.options)
    } else {
      api.reload('2af2bb4d', component.options)
    }
    module.hot.accept("./ProductSwatchesStatic.vue?vue&type=template&id=2af2bb4d&scoped=true&lang=pug&", function () {
      api.rerender('2af2bb4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/bourdain/ProductSwatchesStatic.vue"
export default component.exports